import pool from '../../../lib/db';
import fs from 'fs';
import path from 'path';

export const config = {
    api: {
        bodyParser: {
            sizeLimit: '10mb',
        },
    },
};

export default async function handler(req, res) {
    const { id } = req.query;

    if (req.method === 'DELETE') {
        try {
            await pool.query('DELETE FROM blogs WHERE id = ?', [id]);
            return res.status(200).json({ message: 'Blog deleted successfully' });
        } catch (error) {
            console.error('Delete Error:', error);
            return res.status(500).json({ error: 'Failed to delete blog' });
        }
    }

    if (req.method === 'PUT') {
        const { title, subtitle, description, content, image_url, image_base64, author, status, author_image, author_image_base64, author_role, author_bio, author_linkedin, author_twitter, author_socials } = req.body;
        
        const slug = title.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
        let finalImageUrl = image_url;

        // Process Base64 Image Upload if a new one is provided
        if (image_base64) {
            try {
                const uploadDir = path.join(process.cwd(), 'public', 'uploads');
                if (!fs.existsSync(uploadDir)) {
                    fs.mkdirSync(uploadDir, { recursive: true });
                }

                const matches = image_base64.match(/^data:image\/([A-Za-z-+\/]+);base64,(.+)$/);
                if (matches && matches.length === 3) {
                    const ext = matches[1] === 'jpeg' ? 'jpg' : matches[1];
                    const buffer = Buffer.from(matches[2], 'base64');
                    const fileName = `blog-${Date.now()}.${ext}`;
                    fs.writeFileSync(path.join(uploadDir, fileName), buffer);
                    finalImageUrl = `/projectbim/api/uploads/${fileName}`;
                }
            } catch (err) {
                console.error('Image Upload Error:', err);
            }
        }

        let finalAuthorImageUrl = author_image || '';
        if (author_image_base64) {
            try {
                const uploadDir = path.join(process.cwd(), 'public', 'uploads');
                if (!fs.existsSync(uploadDir)) {
                    fs.mkdirSync(uploadDir, { recursive: true });
                }

                const matches = author_image_base64.match(/^data:image\/([A-Za-z-+\/]+);base64,(.+)$/);
                if (matches && matches.length === 3) {
                    const ext = matches[1] === 'jpeg' ? 'jpg' : matches[1];
                    const buffer = Buffer.from(matches[2], 'base64');
                    const fileName = `author-${Date.now()}.${ext}`;
                    fs.writeFileSync(path.join(uploadDir, fileName), buffer);
                    finalAuthorImageUrl = `/projectbim/api/uploads/${fileName}`;
                }
            } catch (err) {
                console.error('Author Image Upload Error:', err);
            }
        }
        
        try {
            await pool.query(
                'UPDATE blogs SET title = ?, subtitle = ?, description = ?, slug = ?, content = ?, image_url = ?, author = ?, status = ?, author_image = ?, author_role = ?, author_bio = ?, author_linkedin = ?, author_twitter = ?, author_socials = ? WHERE id = ?',
                [title, subtitle || '', description || '', slug, content, finalImageUrl, author || 'Admin', status || 'published', finalAuthorImageUrl, author_role || '', author_bio || '', author_linkedin || '', author_twitter || '', JSON.stringify(author_socials || []), id]
            );
            return res.status(200).json({ message: 'Blog updated successfully', new_image: finalImageUrl });
        } catch (error) {
            console.error('Update Error:', error);
            return res.status(500).json({ error: 'Failed to update blog' });
        }
    }

    return res.status(405).json({ error: 'Method not allowed' });
}
